/**
 * @file コンポーネント：フル動画ページ編集モーダル ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import {
    fnHandleApiErrors,
    fnReplaceLocalizedText,
} from "~/src/functions/common";

// コンポーネントを返す
export const ModalEdit = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * presenterに渡すデータ生成
     */
    const [form, setForm] = useState(null); // form種別
    const [labelType, setLabelType] = useState(null); // モーダル見出し用種別
    useEffect(() => {
        switch (props.type) {
            case "comment": // 執刀医コメント
                setForm("input");
                setLabelType(localized["Label.Comment"]);
                break;
            case "event": // イベント
                setForm("input");
                setLabelType(localized["Label.Event"]);
                break;
            case "postoperation": // 術後情報
                setForm("textarea");
                setLabelType(localized["Label.PostOperation"]);
                break;
            case "preoperation": // 術前情報
                setForm("textarea");
                setLabelType(localized["Label.PreOperation"]);
                break;
            case "summary": // 概要
                setForm("textarea");
                setLabelType(localized["Label.Summary"]);
                break;
            case "surgeon": // 執刀医概要
                setForm("textarea");
                setLabelType(localized["Label.SurgeonSummary"]);
                break;
            case "surgeonuserlist": // 執刀医権限ユーザーリスト
                setLabelType(localized["Label.SurgeonUser"]);
                break;
            case "taglist": // 症例タグリスト
                setLabelType(localized["Label.Tag"]);
                break;
            case "title": // 症例タイトル
                setForm("input");
                setLabelType(localized["Label.OperationTitle"]);
                break;
            default:
        }
    }, [props.type]);
    const [label, setLabel] = useState(null); // モーダル見出し
    useEffect(() => {
        if (labelType !== null) {
            switch (props.mode) {
                case "add":
                    setLabel(
                        fnReplaceLocalizedText(localized["Label.AddContent"], [
                            labelType,
                        ])
                    );
                    break;
                case "delete":
                    setLabel(
                        fnReplaceLocalizedText(
                            localized["Label.DeleteContent"],
                            [labelType]
                        )
                    );
                    break;
                case "edit":
                    setLabel(
                        fnReplaceLocalizedText(localized["Label.EditContent"], [
                            labelType,
                        ])
                    );
                    break;
                default:
            }
        }
    }, [labelType, props.mode]);

    /**
     * メインボタンのクリック時の処理
     */
    const [context, setContext] = useState(null); // フォーム入力内容
    // メインボタンのクリック時の処理関数
    const fnOnClick = async (e) => {
        e.preventDefault();
        let api;
        const options = {
            body: null,
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: document
                    .getElementById("requestverificationtoken")
                    .getAttribute("value"),
            },
            method: "POST",
        };
        if (props.type === "comment") {
            // 執刀医コメント
            if (props.mode === "add") {
                api = "/api/Comments/add";
                options.body = JSON.stringify({
                    commentContext: context,
                    commentTime: props.timeProgressSecond,
                    operationId: window.atob(props.operationId),
                    parentCommentId: null,
                    publicFlg: true,
                    userType: 1,
                });
            } else if (props.mode === "delete") {
                api = "/api/Comments/delete";
                options.body = JSON.stringify({
                    commentId: props.content.id,
                    operationId: window.atob(props.operationId),
                });
            } else if (props.mode === "edit") {
                api = "/api/Comments/edit";
                options.body = JSON.stringify({
                    commentContext:
                        context !== null ? context : props.content.context,
                    commentId: props.content.id,
                    operationId: window.atob(props.operationId),
                });
            }
        } else if (props.type === "event") {
            // イベント
            if (props.mode === "add") {
                api = "/api/Events/add";
                options.body = JSON.stringify({
                    eventContext: context,
                    eventTime: props.timeProgressSecond,
                    operationId: window.atob(props.operationId),
                });
            } else if (props.mode === "delete") {
                api = "/api/Events/delete";
                options.body = JSON.stringify({
                    eventContext: "temp",
                    eventId: props.content.id,
                    operationId: window.atob(props.operationId),
                });
            } else if (props.mode === "edit") {
                api = "/api/Events/edit";
                options.body = JSON.stringify({
                    eventContext:
                        context !== null ? context : props.content.context,
                    eventId: props.content.id,
                    operationId: window.atob(props.operationId),
                });
            }
        } else if (props.type === "postoperation") {
            // 術後情報
            api =
                "/api/AfterOperationContents/" + window.atob(props.operationId);
            options.body = JSON.stringify({
                afterOperationInfo:
                    context !== null ? context : props.content.context,
                operationId: window.atob(props.operationId),
            });
        } else if (props.type === "preoperation") {
            // 術前情報
            api =
                "/api/BeforeOperationContents/" +
                window.atob(props.operationId);
            options.body = JSON.stringify({
                beforeOperationInfo:
                    context !== null ? context : props.content.context,
                operationId: window.atob(props.operationId),
            });
        } else if (props.type === "summary") {
            // 概要
            api = "/api/OperationSummarys/update";
            options.body = JSON.stringify({
                languageCode: props.content.languageCode,
                operationId: window.atob(props.operationId),
                operationSummary:
                    context !== null ? context : props.content.context,
                operationTitle: props.content.title,
            });
        } else if (props.type === "surgeon") {
            // 執刀医略歴
            api = "/api/Surgeondetail/update";
            options.body = JSON.stringify({
                languageCode: props.content.languageCode,
                surgeonSummary:
                    context !== null ? context : props.content.context,
                surgeondetailId: props.content.id,
            });
        } else if (props.type === "title") {
            // 症例タイトル
            api = "/api/OperationSummarys/update";
            options.body = JSON.stringify({
                languageCode: props.content.languageCode,
                operationId: window.atob(props.operationId),
                operationSummary: props.content.summary,
                operationTitle:
                    context !== null ? context : props.content.context,
            });
        }
        // POST処理
        if (api) {
            fetch(api, options)
                .then(fnHandleApiErrors)
                .then((response) => {
                    if (response.status === 200) {
                        if (
                            props.content.targets !== null &&
                            props.content.targets !== undefined &&
                            props.mode === "edit"
                        ) {
                            props.content.targets.forEach((target) => {
                                target.innerText =
                                    context !== null
                                        ? context
                                        : props.content.context;
                            });
                        }
                        if (props.type === "comment") {
                            props.setIsResetListComment(true);
                        } else if (props.type === "event") {
                            props.setIsResetListEvent(true);
                        }
                        props.setIsOpenModalEdit(false);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    /**
     * モーダルを閉じた時にデータをリセットする
     */
    useEffect(() => {
        if (props.isOpenModalEdit === false) {
            props.setModalEditContent(null);
            props.setModalEditMode(null);
            props.setModalEditType(null);
            setForm(null);
        }
    }, [props.isOpenModalEdit]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            fnOnClick={fnOnClick}
            form={form}
            label={label}
            setContext={setContext}
        />
    );
};
